﻿import { reactive } from 'vue';

export const discountStore = reactive({
    state: [],
    updateDiscount(discount) {
        Object.assign(this.state, discount);
    }
});